import { Component } from 'react';

export class NoMatch extends Component {
    render(): JSX.Element {
        return <h1>{'404 - Whoopsie'}</h1>;
    }
}
